// Create custom --vh css var to use instead of vh which has problems on mobile devices when certain UI elements are visible
function setVh() {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVh();
window.addEventListener('resize', setVh);
